import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import { actions } from 'reducers/config';
import { getState } from 'reducers/meta';

const {
  request: loadConfig
} = actions;

const styles = theme => ({
  progress: {
    top: 'calc(50vh - 25px)',
    left: 'calc(50vw - 25px)',
    position: 'absolute'
  },
});

class LoadConfig extends Component {
  static propTypes = {
    loadConfig: PropTypes.func.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]).isRequired,
  };

  componentDidMount = () => {
    this.props.loadConfig();
  };

  render() {
    const {
      isLoaded,
      children,
      classes
    } = this.props;

    if (!isLoaded) {
      return (
        <CircularProgress className={classes.progress} size={50} />
      )
    }

    return <Fragment>
      {children}
    </Fragment>
  }
}

const mapStateToProps = state => ({
  isLoaded: 'success' === getState(state.meta, 'config')
});

const mapDispatchToProps = {
  loadConfig
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(LoadConfig));



// WEBPACK FOOTER //
// ./src/components/LoadConfig.js